import gql from "graphql-tag";

export default gql`
  mutation deleteAsset($assetId: ID, $customerId: ID) {
    deleteAsset(assetId: $assetId, customerId: $customerId) {
      id
      codename
    }
  }
`;
